import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import BlogVisitCounter from '../Common/BlogVisitCounter';

const BlogPostCard = ({ post }) => {

  return (
    <article className="blog-post-card">
      <div className="blog-post-card__image-container">
        {post.main_image_url ? (
          <img 
            src={post.main_image_url} 
            alt={post.title}
            className="blog-post-card__image"
          />
        ) : (
          <div className="blog-post-card__image-placeholder">
            <FontAwesomeIcon icon={faEye} />
          </div>
        )}
        

      </div>
      
      <div className="blog-post-card__content">
        <div className="blog-post-card__meta">
          {post.category && (
            <div className="blog-post-card__category-text">
              {post.category.name}
            </div>
          )}
          <BlogVisitCounter postSlug={post.slug} postData={post} className="blog-post-card__visit-counter" />
        </div>
        
        <h3 className="blog-post-card__title">
          <Link to={`/blog/${post.slug}`}>
            {post.title}
          </Link>
        </h3>
        
        <Link to={`/blog/${post.slug}`} className="blog-post-card__read-more">
          <span>Read More</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </article>
  );
};

export default BlogPostCard; 